import { Skeleton } from "@mui/material";
import { AvailabilityStatus } from "@src/pages/subGroupDetail/subgroupDetailsListSection/availabilityStatus/AvailabilityStatus";
import { type SPFArticleWithPriceInfo } from "@src/utils/events";
import * as React from "react";

interface AvailabilityStatusCellProps {
    sparePart: SPFArticleWithPriceInfo;
}

export const AvailabilityStatusCell: React.FunctionComponent<AvailabilityStatusCellProps> = ({ sparePart }) => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 5000);
    }, []);

    return loading && !sparePart.clientArticleInfo ? (
        <Skeleton height={20} width={100} />
    ) : sparePart.clientArticleInfo?.availability ? (
        <AvailabilityStatus
            availabilityStatus={sparePart.clientArticleInfo.availability}
            customText={sparePart.clientArticleInfo?.availabilityText}
        />
    ) : null;
};
